export default __webpack_public_path__ + "static/media/QUICK.959d598d.png";